module.exports = __webpack_public_path__ + "img/seafood.7d7d1402.svg";